const panels = document.querySelectorAll('.side-panel__toggle');
Array.prototype.forEach.call(panels,function(el){
    el.addEventListener('click',function(){
        if(el.parentElement.classList.contains('side-panel--is-open')){
            el.parentElement.classList.remove('side-panel--is-open')
        }else{
            Array.prototype.forEach.call(panels,function(p){
                p.parentElement.classList.remove('side-panel--is-open')
            });
            el.parentElement.classList.add('side-panel--is-open')
        }
    });
})